import React, { useEffect } from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import Img from "./Img"

import * as styles from "./banner.module.scss"
import { useObserver } from "../../../hooks"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

const titleDefault = (
  <>
    10&nbsp;месяцев <br />
    без&nbsp;процентов*
  </>
)

const deskDefault = (
  <>
    {" "}
    Бесплатные кредитные карты <br className="d-ld-none" />
    Совкомбанка
  </>
)

type BannerProps = {
  buttonText?: string
  orderNum?: string
  title?: JSX.Element | string
  desk?: JSX.Element | string
}

export function Banner({
  buttonText = "Оформить",
  orderNum,
  title = titleDefault,
  desk = deskDefault,
}: BannerProps) {
  useEffect(() => {
    document.body.style.display = "block"
  }, [])

  const isVisible = useObserver(["formPkw"])

  return (
    <>
      <section className={styles.section} data-exclude={orderNum}>
        <Container className={styles.container}>
          <div className={clsx(styles.secondContainer)}>
            <Img alt="bg image" className={styles.img} />

            <div className={styles.text}>
              <h1>{title}</h1>
              <p>{desk}</p>
            </div>
            <Button className={styles.btn} onClick={() => handleClickBanner(buttonText, title)}>
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
